import * as R from "ramda";

import {
  RESET_SELECTED_CANDIDATES,
  SELECT_CANDIDATES,
  SELECT_CANDIDATE,
  SET_STEP_FILTERS,
  RESET_FILTERS
} from "../actions/process";

const initialState = {
  selectedCandidates: [],
  selectedCandidatesStep: null,
  filters: {} // Filters by step id
};

const process = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case RESET_SELECTED_CANDIDATES.TYPE:
      return R.evolve(
        {
          selectedCandidates: R.always([]),
          selectedCandidatesStep: R.always(null)
        },
        state
      );

    case SELECT_CANDIDATES.TYPE: {
      const { candidates, isChecked } = payload;

      return R.evolve(
        {
          selectedCandidates: isChecked ? R.always(candidates) : R.empty,
          selectedCandidatesStep: isChecked ? R.identity : R.always(null)
        },
        state
      );
    }

    case SELECT_CANDIDATE.TYPE:
      const { candidate, selected, step } = payload;
      const prevState = R.pick(
        ["selectedCandidates", "selectedCandidatesStep"],
        state
      );

      const isDifferentStep =
        !prevState.selectedCandidatesStep ||
        prevState.selectedCandidatesStep.id === step.id;

      // TODO make this logic nicer
      return R.evolve(
        {
          selectedCandidates: isDifferentStep
            ? selected
              ? R.append(candidate)
              : R.filter(
                  R.compose(
                    R.not,
                    R.propEq("id", R.prop("id", candidate))
                  )
                )
            : R.identity,
          selectedCandidatesStep: isDifferentStep
            ? selected
              ? R.always(step)
              : R.not(R.equals(1, R.length(prevState.selectedCandidates)))
              ? R.identity
              : R.always(null)
            : R.identity
        },
        state
      );

    case RESET_FILTERS.TYPE: {
      return R.assoc("filters", {}, state);
    }

    case SET_STEP_FILTERS.TYPE: {
      return R.pipe(
        R.assocPath(["filters", payload.stepId], payload.filters),
        // If selection is enabled remove filtered candidates
        R.when(
          () => payload.newSelectedCandidates,
          R.assoc("selectedCandidates", payload.newSelectedCandidates)
        ),
        // If after applying filters there is no selected candidate
        // remove selectedCandidatesStep from state
        R.when(
          () =>
            payload.newSelectedCandidates &&
            !payload.newSelectedCandidates.length,
          R.assoc("selectedCandidatesStep", null)
        )
      )(state);
    }

    default:
      return state;
  }
};

export default process;
